import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-faq-page',
  templateUrl: './faq-page.component.html',
  styleUrls: ['./faq-page.component.css']
})
export class FaqPageComponent implements OnInit {


  @ViewChild('question') question: ElementRef<HTMLDivElement>;

  constructor() { }

  ngOnInit(): void {
  }

  scrollToElement(label): void {

    switch(label){
      case 'question':
        this.question.nativeElement.scrollIntoView({ behavior: 'smooth'});
        break;
    }
  }

}
